import React from 'react';
import { Zap } from 'lucide-react';
import SubscribeBox from './SubscribeBox';

const HeroSection = () => {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-slate-50 via-white to-blue-50" />

      <div className="container mx-auto px-4 relative z-10 pt-20">
        <div className="max-w-4xl mx-auto text-center">

          <div className="inline-flex items-center gap-2 bg-white/80 px-4 py-2 rounded-full shadow mb-8">
            <Zap size={18} className="text-[#4A9FD8]" />
            <span className="text-sm font-semibold text-gray-700">
              استضافة عالية الأداء
            </span>
          </div>

          <h1 className="text-5xl md:text-7xl font-bold mb-6">
            <span className="text-gray-800">استضافة مواقع</span><br />
            <span className="text-transparent bg-clip-text bg-gradient-to-l from-[#4A9FD8] to-[#2E7FB8]">
              سريعة وآمنة
            </span>
          </h1>

          <p className="text-xl text-gray-600 mb-12">
            احصل على استضافة موثوقة بأداء استثنائي وأمان متقدم
          </p>

          {/* صندوق التواصل */}
          <div className="max-w-xl mx-auto">
            <div className="bg-white rounded-2xl shadow-xl p-8">
              <h3 className="text-2xl font-bold mb-2">تواصل معنا الآن</h3>
              <p className="text-gray-600 mb-6">
                ابدأ رحلتك مع استضافة موثوقة وسريعة
              </p>

              <SubscribeBox />
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 mt-16 max-w-2xl mx-auto">
            <div className="bg-white rounded-xl p-6 shadow">
              <div className="text-4xl font-bold text-[#4A9FD8]">99.9%</div>
              <div className="text-gray-600">وقت التشغيل</div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow">
              <div className="text-4xl font-bold text-[#4A9FD8]">24/7</div>
              <div className="text-gray-600">دعم فني</div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HeroSection;
